import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconEye: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#00795B',
  disabled = false,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.157 6.75879C13.2816 5.29279 11.3169 2.8335 8.00024 2.8335C4.68357 2.8335 2.71883 5.29279 1.8435 6.75879C1.3855 7.52412 1.3855 8.47554 1.8435 9.24154C2.71883 10.7075 4.68357 13.1668 8.00024 13.1668C11.3169 13.1668 13.2816 10.7075 14.157 9.24154C14.615 8.47554 14.615 7.52479 14.157 6.75879ZM13.2989 8.72819C12.5322 10.0122 10.8236 12.1668 8.00024 12.1668C5.17691 12.1668 3.46824 10.0129 2.70157 8.72819C2.43357 8.27886 2.43357 7.72082 2.70157 7.27148C3.46824 5.98748 5.17691 3.83285 8.00024 3.83285C10.8236 3.83285 12.5322 5.98682 13.2989 7.27148C13.5676 7.72148 13.5676 8.27886 13.2989 8.72819ZM8.00024 5.16683C6.43757 5.16683 5.16691 6.43816 5.16691 8.00016C5.16691 9.56216 6.43757 10.8335 8.00024 10.8335C9.56291 10.8335 10.8336 9.56216 10.8336 8.00016C10.8336 6.43816 9.56291 5.16683 8.00024 5.16683ZM8.00024 9.8335C6.98891 9.8335 6.16691 9.0115 6.16691 8.00016C6.16691 6.98883 6.98891 6.16683 8.00024 6.16683C9.01157 6.16683 9.83357 6.98883 9.83357 8.00016C9.83357 9.0115 9.01157 9.8335 8.00024 9.8335Z"
      fill={disabled ? 'rgba(92, 101, 110, 1)' : color}
    />
  </svg>
);

export default IconEye;
